/** @jsx jsx */
import { jsx } from '@emotion/react';

import InlineLearningGoalQuestion from 'bundles/onboarding-common/components/InlineLearningGoalQuestion';

const LoggedOutProgressiveOnboardingRenderer = () => {
  return <InlineLearningGoalQuestion />;
};

export default LoggedOutProgressiveOnboardingRenderer;
